import React, { Fragment, useEffect, useMemo, useState } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import InputComponent from "../../components/InputComponent";
import stylebtn from "../../styles/btn.module.scss";
import PaginadorComponent from "../../components/PaginadorComponent";
import LoaderComponent from "../../components/LoaderComponent";
import AlertComponent from "../../components/AlertComponent";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  deleteVentaRapidas,
  editarFechaV,
  getVentaRapidas,
} from "../../api/ApiVenta";
import { useFormatter } from "../../hooks/useFormatter";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import EstadoFacturaComponent from "../../components/EstadoFacturaComponent";
import ParrafoComponent from "../../components/ParrafoComponent";
import TitleH4Component from "../../components/TitleH4Component";
import { useAuth } from "../../context/AuthContext";
import SelectComponent from "../../components/SelectComponent";
import stylegenral from "../../styles/general.module.scss";
import { getUsers } from "../../api/Users";
import { useVentasMensuales } from "../../hooks/useVentasMensuales";
import { inventarioVR } from "../../api/Inventario";
const VentasRealizadasPages = () => {
  //Data de paginador
  const [estadoF, setEstadoF] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [ventas, setVentas] = useState([]);
  const { formatDate, formatDateUTC, formtTodayBogota, formatDateInput } = useFormatter();
  const [busqueda, setBusqueda] = useState("");
  const [showEliminar, setShowEliminar] = useState(false);
  const [id, setId] = useState(false);
  const [mensajealerta, setMensajealerta] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [mensaje, setMensaje] = useState("");
  const [showFechaModal, setShowFechaModal] = useState(false);
  const [currentFactura, setCurrentFactura] = useState({});
  //const [dataUsers, setDataUser] = useState([]);
  const [users, setUser] = useState("");
  const [datosVR, setDatosVR] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [formDataFecha, setFormDataFecha] = useState({
    fecha_vencimiento: "",
    fecha_creacion: "",
  });

  const hoy = formtTodayBogota();
  const [formDataFechaBusqueda, setFormDataFechaBusqueda] = useState({
    fechaI: "",
    fechaFin: "",
  });

  const { isAdmin, isSuper, idUser } = useAuth();

  const esVenta = "venta";
  const esElaboracion = "elaboracion";
  const navigate = useNavigate();
  const location = useLocation();
  // Manejar el cambio en el input
  const handleChangeBusqueda = (event) => {
    setBusqueda(event.target.value);
  };

 

  const {
    productosMesActual,
    productosMesAnterior,
    totalMesActual,
    totalMesAnterior,
    totalAbonosMesActual,
  } = useVentasMensuales(ventas);

  const hayFiltros =
    formDataFechaBusqueda.fechaI || formDataFechaBusqueda.fechaFin;
  const dataTabla = hayFiltros ? ventas : productosMesActual;

  const itemsPerPage = 7;
  const pageCount = Math.ceil(ventas.length / itemsPerPage);
  const currentPageDateVR = ventas.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage,
  );

  const optionState = [
    { value: "1", label: "ABIERTO" },
    { value: "0", label: "CERRADO" },
    { value: "2", label: "PENDIENTE" },
    { value: "3", label: "VENCIDA" },
  ];

  // Manejar el cambio en el input de fechas: filtra automáticamente
  const handleInputChangeFechaBusqueda = (e) => {
    const { name, value } = e.target;
    const nuevaFecha = { ...formDataFechaBusqueda, [name]: value };
    setFormDataFechaBusqueda(nuevaFecha);
    aplicarFiltros({
      fechaIVal: nuevaFecha.fechaI,
      fechaFinVal: nuevaFecha.fechaFin,
    });
  };
 
  // Manejar el cambio en el input
  const handleInputChangeFecha = (e) => {
    setFormDataFecha({
      ...formDataFecha,
      [e.target.name]: e.target.value,
    });
  };

  //Metodo para obtener las ventas rapidas
  const ventasrapidas = async (filters = {}) => {
    const { status, res } = await getVentaRapidas(filters);
    if (status === 200) {
      setVentas(res?.data); // guardas ventas en el estado     
    } else {
      console.error("Error:", res?.data);
    }
  };
//---------------------------------------------------NEW DAY

const getSelectedValue = (selected) =>
  selected && typeof selected === "object" ? selected.value : selected ?? "";

const addOneDay = (dateValue) => {
  if (!dateValue) return null;

  let date;

  if (typeof dateValue === "string") {
    // Espera formato yyyy-mm-dd
    const [y, m, d] = dateValue.split("-").map(Number);

    if (!y || !m || !d) return null;

    date = new Date(y, m - 1, d);
  } else if (dateValue instanceof Date) {
    date = new Date(dateValue);
  } else {
    return null;
  }

  date.setDate(date.getDate() + 1);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const getFiltersFromSearch = (search) => {
  const params = new URLSearchParams(search);

  const query = params.get("search") || "";
  const estado = params.get("estado") || "";
  const user = params.get("user") || "";
  const all = params.get("all") === "1";

  const hasRealFilters =
    query || estado || user || params.get("fechaI") || params.get("fechaFin");

  let fechaI = "";
  let fechaFin = "";

  // Caso 1: sin params => vista por defecto de hoy
  if (!all && !hasRealFilters) {
    fechaI = hoy;
    fechaFin = hoy;
  } else {
    // Caso 2: filtros reales o all=1 => respetar URL
    fechaI = params.get("fechaI") || "";
    fechaFin = params.get("fechaFin") || "";
  }

  return {
    ui: {
      query,
      estado,
      user,
      fechaI,
      fechaFin,
    },
    apiVentas: {
      isVenta: esVenta,
      esElaboracion,
      searchQuery: query,
      estado,
      id_user: user,
      startDate: fechaI || null,
      endDate: addOneDay(fechaFin),
    },
    apiVR: {
      fechaInicio: fechaI || "",
      fechaFin: fechaFin || "",
      ...(user ? { usuario: user } : {}),
    },
  };
};

useEffect(() => {
  const { ui, apiVentas, apiVR } = getFiltersFromSearch(location.search);

  setBusqueda(ui.query);
  setEstadoF(ui.estado);
  setUser(ui.user);
  setFormDataFechaBusqueda({
    fechaI: ui.fechaI,
    fechaFin: ui.fechaFin,
  });

  const loadData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        ventasrapidas(apiVentas),
        cargarDatosVR(apiVR),
      ]);
    } catch (error) {
      console.error("Error cargando ventas y totales", error);
    } finally {
      setLoading(false);
    }
  };

  loadData();
}, [location.search]);
  //----------------------------------------------------------
  // metodo para filtrar un producto de la factura venta rapida
  // Construye los query params a partir de los filtros actuales, permitiendo
  // sobreescribir alguno puntual (para poder filtrar apenas se elige, sin
  // esperar a que React termine de actualizar el estado).
  const aplicarFiltros = (overrides = {}) => {
    const {
      busquedaVal = busqueda,
      estadoVal = estadoF,
      userVal = users,
      fechaIVal = formDataFechaBusqueda.fechaI,
      fechaFinVal = formDataFechaBusqueda.fechaFin,
    } = overrides;

    const params = new URLSearchParams();

    if (busquedaVal) params.set("search", busquedaVal);
    if (estadoVal !== "" && estadoVal !== null) params.set("estado", String(estadoVal));
    if (userVal !== "" && userVal !== null) params.set("user", String(userVal));
    if (fechaIVal) params.set("fechaI", fechaIVal);
    if (fechaFinVal) params.set("fechaFin", fechaFinVal);

    // Si no hay ningún filtro, traer toda la data
    if ([...params.keys()].length === 0) {
      params.set("all", "1");
    }

    setCurrentPage(0);
    navigate(`?${params.toString()}`);
  };

  const handleFilterClick = (e) => {
    e.preventDefault();
    aplicarFiltros();
  };
//---------------------------------------------------------------- THE END
  // Metodos para el popup de eliminar
  const handleCloseEliminar = () => setShowEliminar(false);
  const handleShowEliminar = (id) => {
    setId(id);
    setShowEliminar(true);
  };

  //Metodo para eliminar la venta
  const eliminarVenta = async () => {
    const { status, res } = await deleteVentaRapidas(id);
    if (status === 200) {
      setShowEliminar(false);
      setAlert(true);
      setMensajealerta(res.msg);

      const { apiVentas, ui, apiVR } = getFiltersFromSearch(location.search);

      // restaurar inputs
      setBusqueda(ui.query);
      setEstadoF(ui.estado);
      setUser(ui.user);
      setFormDataFechaBusqueda({
        fechaI: ui.fechaI,
        fechaFin: ui.fechaFin,
      });
      try {
        setLoading(true);
        await Promise.all([ventasrapidas(apiVentas), cargarDatosVR(apiVR)]);
      } finally {
        setLoading(false);
      }
    }

    setTimeout(() => {
      setAlert(false);
    }, 5000);
  };

  //---------------------------------//
  //------ Metodo editar Fecha ------//
  //---------------------------------//
  const handleShowFecha = (venta) => {
    setCurrentFactura(venta); // guardamos la venta actual
    setFormDataFecha({
      id_user: venta?.id || "",
      fecha_vencimiento: venta?.fecha_vencimiento
        ? formatDateInput(venta?.fecha_vencimiento, "UTC")
        : "",
      fecha_creacion: venta?.fecha_creacion
        ? formatDateInput(venta?.fecha_creacion, "UTC")
        : formatDateInput(venta?.createdAt),
    });
    setId(venta?.id);
    setShowFechaModal(true);
  };

  const editarFechaVencimiento = async (e) => {
    e.preventDefault();
    try {
      const res = await editarFechaV(id, formDataFecha);

      if (res.success) {
        const { apiVentas, ui, apiVR } = getFiltersFromSearch(location.search);

        setBusqueda(ui.query);
        setEstadoF(ui.estado);
        setUser(ui.user);
        setFormDataFechaBusqueda({
          fechaI: ui.fechaI,
          fechaFin: ui.fechaFin,
        });

        setAlert(true);
        setMensajealerta(res.msg);
        try{setLoading(true);
          await Promise.all([ventasrapidas(apiVentas),
        cargarDatosVR(apiVR)])
        }finally{
          setLoading(false)
        }
        
        setShowFechaModal(false);
      } else {
        setMensaje(res.msg);
      }
    } catch (error) {
      console.error(error);
      setMensaje("Error al actualizar la fecha");
    }
    setTimeout(() => {
      setAlert(false);
      setMensaje("");
    }, 3000);
  };

  const limpiarFilter = () => {
  setEstadoF("");
  setUser("");
  setBusqueda("");
  setFormDataFechaBusqueda({ fechaI: "", fechaFin: "" });
  setCurrentPage(0);

  navigate("?all=1");
};
  
  // ==========================================
  //            Opciones para Selects
  // =================Evita que se vuelva a ejecutar en cada render=========================
  const optionsUsuarios = useMemo(() => {
    if (!Array.isArray(usuarios)) return [];
    return usuarios.map((user) => ({
      value: user.id,
      label: user.nombre,
    }));
  }, [usuarios]);

  // Cargar usuarios al montar
  useEffect(() => {
    const cargarUsuarios = async () => {
      try {
        const response = await getUsers();
        setUsuarios(response.data);
      } catch (error) {
        console.error("Error cargando usuarios", error);
        setUsuarios([]);
      }
    };
    cargarUsuarios();
  }, []);

  // ==========================================
  //      Cargar ventas rapidas
  // ==========================================
  const cargarDatosVR = async (filters = {}) => {
    try {
      const vr = await inventarioVR(filters);
      setDatosVR(vr);
    } catch (error) {
      console.error("Erro al cargar informacion VR", error);
    }
  };

  const total =
    Number(datosVR?.totalContadoVR ?? 0) +
    Number(datosVR?.totalAbonosVR ?? 0) +
    Number(datosVR?.totalSoloElaboracion ?? 0) +
    Number(datosVR?.totalTransporteVR ?? 0);

  const totalMes =
    Number(totalMesActual ?? 0) + Number(totalAbonosMesActual ?? 0);


  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <AlertComponent
          styleGroup="bg-soccess color-white"
          mensaje={mensajealerta}
          activaalert={alert}
        />
      </div>
      <HeaderComponent>
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          VENTA RAPIDAS
        </TitleH2Component>
        <div className="d-flex align-items-center justify-content-start flex-wrap gap-2 flex-column flex-md-row">
          <Link
            to="/venta-rapida?tipo=venta"
            className={`${stylebtn.btn} ${stylebtn.primary} ${stylebtn.btnMovil}`}
          >
            REALIZAR VENTA
          </Link>

          <Link
            to="/cotizaciones-realizadas"
            className={`${stylebtn.btn} ${stylebtn.primary} ${stylebtn.btnMovil}`}
          >
            COTIZACION
          </Link>

          <Link
            to="/venta-rapida?tipo=elaboracion"
            className={`${stylebtn.btn} ${stylebtn.primary} ${stylebtn.btnMovil} `}
          >
            ELABORACION DE MADERA
          </Link>        
        </div>
      </HeaderComponent>

      <div className="conatiner-global pt-3 mb-5">
        <section>
          <div className="container">
            <form action="" onSubmit={handleFilterClick}>
              <div className="row gy-4 mb-4">
                <div className="col-12 col-md-6 col-xl-3">
                  <SelectComponent
                    label="Estado"
                    value={
                      optionState.find(
                        (option) => String(option.value) === String(estadoF),
                      ) || null
                    }
                    capOpcions={(selected) => {
                      const value = getSelectedValue(selected);
                      setEstadoF(value);
                      aplicarFiltros({ estadoVal: value });
                    }}
                    options={optionState}
                    styleGroup={`${stylegenral.wselect}`}
                    styleLabel="fw600 WorkSans color-madera"
                    customPlaceholder="Estado"
                    isClearable
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <SelectComponent
                    label="Vendedor"
                    styleGroup={`${stylegenral.wselect}`}
                    styleLabel="fw600 WorkSans color-madera"
                    customPlaceholder="Seleccionar"
                    options={optionsUsuarios}
                    capOpcions={(selected) => {
                      const value = getSelectedValue(selected);
                      setUser(value);
                      aplicarFiltros({ userVal: value });
                    }}
                    name="user"
                    value={
                      optionsUsuarios.find(
                        (o) => String(o.value) === String(users),
                      ) || null
                    }
                    isClearable
                  />
                </div>
              </div>
              <div className="row gy-4 ">
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Fecha Inicio:"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="date"
                    name="fechaI"
                    value={formDataFechaBusqueda.fechaI}
                    onChange={handleInputChangeFechaBusqueda}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Fecha Final:"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="date"
                    name="fechaFin"
                    value={formDataFechaBusqueda.fechaFin}
                    onChange={handleInputChangeFechaBusqueda}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    placeholder="Comprador"
                    label="Buscar Comprador"
                    styleLabel="fw600 WorkSans"
                    htmlFor="busqueda"
                    type="search"
                    name="busqueda"
                    value={busqueda}
                    onChange={handleChangeBusqueda}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-2 d-flex justify-content-start">
                  <button
                    type="submit"
                    className={`${stylebtn.btn} ${stylebtn.primary}  mt-4`}
                  >
                    BUSCAR
                  </button>
                </div>

                <div className="col-12 col-md-6 col-xl-2 d-flex justify-content-start">
                  <button
                    type="button"
                    className={`${stylebtn.btn} ${stylebtn.secundary} `}
                    onClick={limpiarFilter}
                  >
                    Limpiar filtros
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>
        {loading ? (
          <LoaderComponent styleGroup="mt-5" />
        ) : (
          <section>
            <div className="mt-4">
              <div className="d-lg-flex align-items-center gap-4 justify-content-between">
                {/* Este se quedará a la izquierda (inicio) */}
                <ParrafoComponent styleGroup="box-text fw700 roboto">
                  Ventas/modificadas
                  <span style={{ color: "Green" }}>
                    {" " + ventas.length.toLocaleString("es-ES")}
                  </span>
                </ParrafoComponent>

                {/* Contenedor interno para agrupar los totales a la derecha */}
                <div className="d-lg-flex gap-4">
                  {isSuper && (
                    <ParrafoComponent styleGroup="box-text fw700 roboto">
                      Total ventas
                      <span style={{ color: "Green" }}>
                        {" $ " +
                          (datosVR?.totalContadoVR || 0).toLocaleString(
                            "es-ES",
                          )}
                      </span>
                    </ParrafoComponent>
                  )}

                  {isSuper && (
                    <ParrafoComponent styleGroup="box-text fw700 roboto">
                      Total Elaboracion
                      <span style={{ color: "Green" }}>
                        {" $ " +
                          (datosVR?.totalSoloElaboracion || 0).toLocaleString(
                            "es-ES",
                          )}
                      </span>
                    </ParrafoComponent>
                  )}

                  {isSuper && (
                    <ParrafoComponent styleGroup="box-text fw700 roboto">
                      Total abonos
                      <span style={{ color: "Green" }}>
                        {" $ " +
                          (datosVR?.totalAbonosVR || 0).toLocaleString("es-ES")}
                      </span>
                    </ParrafoComponent>
                  )}

                  {isSuper && (
                    <ParrafoComponent styleGroup="box-text fw700 roboto">
                      Total transporte
                      <span style={{ color: "Green" }}>
                        {" $ " +
                          (datosVR?.totalTransporteVR || 0).toLocaleString(
                            "es-ES",
                          )}
                      </span>
                    </ParrafoComponent>
                  )}

                  {isSuper && (
                    <ParrafoComponent styleGroup="box-text fw700 roboto">
                      Total
                      <span style={{ color: "green" }}>
                        {" $ " + (total || 0).toLocaleString("es-ES")}
                      </span>
                    </ParrafoComponent>
                  )}
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered tableGeneral">
                  <thead>
                    <tr className="bg-light border-bottom">
                      <th
                        scope="col"
                        className="color-madera py-3 text-center"
                        style={{ width: "50px" }}
                      >
                        <small className="fw-bold">#</small>
                      </th>
                      <th scope="col" className="color-madera py-3 text-nowrap">
                        <i className="bi bi-hash me-1"></i>N° Factura
                      </th>
                      <th scope="col" className="color-madera py-3">
                        Documento
                      </th>
                      <th scope="col" className="color-madera py-3 text-nowrap">
                        Comprador
                      </th>
                      <th scope="col" className="color-madera py-3">
                        Dirección
                      </th>
                      <th scope="col" className="color-madera py-3">
                        Celular
                      </th>
                      <th scope="col" className="color-madera py-3 text-end">
                        Financiado
                      </th>
                      <th scope="col" className="color-madera py-3 text-end">
                        Total
                      </th>
                      <th scope="col" className="color-madera py-3 text-center">
                        Pago
                      </th>
                      <th scope="col" className="color-madera py-3 text-center">
                        Factura
                      </th>
                      <th scope="col" className="color-madera py-3 d-none">
                        Tipo
                      </th>
                      <th scope="col" className="color-madera py-3">
                        Vendedor
                      </th>
                      <th scope="col" className="color-madera py-3 text-center">
                        Estado
                      </th>

                      {/* Columnas de acción con ancho fijo para que no bailen */}
                      <th
                        scope="col"
                        className="color-madera py-3 text-center"
                        style={{ width: "60px" }}
                      >
                        Ver
                      </th>
                      <th
                        scope="col"
                        className="color-madera py-3 text-center"
                        style={{ width: "60px" }}
                      >
                        Editar
                      </th>
                      {isAdmin && (
                        <>
                          <th
                            scope="col"
                            className="color-madera py-3 text-center"
                            style={{ width: "60px" }}
                          >
                            Borrar
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                  {ventas.length > 0 ? (
                    <tbody>
                      {currentPageDateVR.map((venta, index) => {
                        return (
                          <tr key={index}>
                            <th>{currentPage * itemsPerPage + index + 1}</th>
                            <th>{venta?.numeroFactura}</th>
                            <th>
                              {venta?.cedula || venta?.Cliente?.Persona?.cedula}
                            </th>
                            <td>
                              {venta?.nombre || venta?.Cliente?.Persona?.nombre}{" "}
                              {venta?.Cliente?.Persona?.apellido || ""}
                            </td>
                            <td>
                              {venta?.direccion ||
                                venta?.Cliente?.Persona?.direccion}
                            </td>
                            <td>
                              {venta?.telefono ||
                                venta?.Cliente?.Persona?.celular}
                            </td>

                            <td>
                              {venta?.estado === 1
                                ? "$" +
                                  Number(
                                    Number(venta?.total ?? 0) +
                                      Number(venta?.transporte ?? 0) -
                                      venta?.total_pagado -
                                      Number(venta?.descuento ?? 0),
                                  ).toLocaleString("es-ES")
                                : "Paga"}
                            </td>
                            <td>
                              {" "}
                              $
                              {(
                                Number(venta?.total ?? 0) +
                                Number(venta?.transporte ?? 0) -
                                Number(venta?.descuento ?? 0)
                              ).toLocaleString("es-ES")}
                            </td>
                            <td>{formatDateUTC(venta?.fecha_vencimiento)}</td>
                            <td>
                              {venta?.fecha_creacion
                                ? formatDateUTC(venta?.fecha_creacion)
                                : formatDate(venta?.createdAt)}
                            </td>
                            {/**<td
                              style={{
                                backgroundColor:
                                  venta?.tipo === "elaboracion"
                                    ? "#007bff"
                                    : "#d6a317",
                                color:
                                  venta?.tipo === "elaboracion"
                                    ? "white"
                                    : "white",
                                padding: "8px",
                                borderRadius: "4px", // Opcional, para que parezca un "cuadro"
                                textAlign: "center",
                              }}
                            >
                              {venta?.tipo}
                            </td>*/}
                            <td>{venta?.User?.nombre || venta?.vendedor}</td>
                            <EstadoFacturaComponent
                              estado={venta?.estado}
                              fechaVencimiento={venta?.fecha_vencimiento}
                            />

                            <td className="text-center">
                              <Link
                                to={`/detalle-venta/${venta?.id}`}
                                className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex`}
                              >
                                <Icon icon="mdi:file-search-outline" />
                              </Link>
                            </td>
                            <td className="text-center">
                              <button
                                onClick={() => handleShowFecha(venta)}
                                className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex`}
                                disabled={venta?.estado !== 1}
                              >
                                <Icon
                                  className={`${
                                    venta?.estado !== 1 ? "" : "color-dark"
                                  }`}
                                  icon="lucide:calendar"
                                />
                              </button>
                            </td>
                            {isAdmin && (
                              <td className="text-center">
                                <button
                                  className={`${stylebtn.btn_desnudo} ${
                                    stylebtn.icon
                                  } ms-3 p-0 d-inline-flex ${
                                    venta?.estado !== 0 ? "" : "color-danger"
                                  } `}
                                  onClick={() => handleShowEliminar(venta?.id)}
                                  disabled={venta?.estado !== 0}
                                >
                                  <Icon icon="majesticons:delete-bin" />
                                </button>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={12} className="text-center">
                          SIN VENTAS
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
            {pageCount > 1 && (
              <PaginadorComponent
                setCurrentPage={setCurrentPage}
                pages={pageCount}
                styleGroup="d-flex justify-content-center pt-4"
              />
            )}
          </section>
        )}

        {/** modal editar Fecha de vencimiento**/}
        <ModalGeneralComponent
          styleGroup="d-flex align-items-center modal-general"
          styleTitle="box-text color-madera fw700 roboto text-center WorkSans"
          show={showFechaModal}
          handleClose={() => setShowFechaModal(false)}
        >
          <div className="container">
            <form onSubmit={editarFechaVencimiento}>
              <div className="d-flex align-items-start justify-content-between">
                <div>
                  <TitleH4Component styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                    {currentFactura?.nombre}
                  </TitleH4Component>
                  <ParrafoComponent styleGroup="box-text color-dark fw700 roboto mb-1 text-center">
                    CC: {currentFactura?.cedula}
                  </ParrafoComponent>
                </div>
              </div>

              <ParrafoComponent styleGroup="box-text color-danger fw700 roboto text-center">
                {mensaje}
              </ParrafoComponent>

              <div className="row mb-4 gap-3 gap-md-0">
                <div className="col-12 col-md-6 ">
                  <InputComponent
                    label="Fecha de pago"
                    type="date"
                    name="fecha_vencimiento"
                    value={formDataFecha.fecha_vencimiento}
                    onChange={handleInputChangeFecha}
                    className="form-control"
                  />
                </div>

                <div className="col-12 col-md-6">
                  <InputComponent
                    label="Fecha de facturación"
                    type="date"
                    name="fecha_creacion"
                    value={formDataFecha.fecha_creacion}
                    onChange={handleInputChangeFecha}
                    className="form-control"
                    disabled={!isAdmin}
                  />
                </div>
              </div>

              <div className="d-flex w-100 justify-content-end">
                <button
                  type="button"
                  className={`${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3`}
                  onClick={() => setShowFechaModal(false)}
                >
                  CANCELAR
                </button>
                <button
                  type="submit"
                  className={`btn ${stylebtn.btn} ${stylebtn.primary}`}
                >
                  GUARDAR
                </button>
              </div>
            </form>
          </div>
        </ModalGeneralComponent>

        {/** modal eliminar un producto del carrito **/}
        <section>
          <ModalGeneralComponent
            styleGroup="d-flex align-items-center modal-general "
            styleTitle={
              "box-text color-madera fw700 roboto text-center WorkSans"
            }
            show={showEliminar}
            handleClose={handleCloseEliminar}
          >
            <form action="">
              <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`Seguro que quiere eliminar la venta rapida`}</TitleH2Component>

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  onClick={handleCloseEliminar}
                  className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                  onClick={eliminarVenta}
                >
                  SI
                </button>
              </div>
            </form>
          </ModalGeneralComponent>
        </section>
      </div>
    </Fragment>
  );
};;

export default VentasRealizadasPages;
